import React, { useContext, useEffect, useState } from "react";
import { LabelText, TitleText } from "../../../ui/Text";
import styled from "styled-components";
import { SmallLineGraph } from "../../../components/SmallLineGraph/SmallLineGraph";
import numeral from "numeral";
import { ProgressCard } from "../../../components/ProgressCard/ProgressCard";
import { ScorecardSubject } from "../../../subjects/ScorecardSubject";
import { TASKS_URL } from "../../../api/urls";
import { GetHook } from "../../../api/api";
import Axios from "axios";
interface StatsProps {
  title: string;
  target?: number;
  weightedScore?: number;
  progress?: number;
  actual?: string;
  variance?: string;
  initiativesTotal?: number;
}

type STATS = {
  completed_tasks: number;
  completion_rate: number;
};

const SummaryStatistcs = ({
  title,
  target,
  weightedScore,
  progress,
  actual,
  variance,
  initiativesTotal,
}: StatsProps) => {
  // const Data = [
  //   { x: new Date(2019, 4, 17), y: 10 },
  //   { x: new Date(2019, 4, 18), y: 40 },
  //   { x: new Date(2019, 4, 19), y: 20 },
  //   { x: new Date(2019, 4, 20), y: 60 },
  //   { x: new Date(2019, 4, 21), y: 0 },
  //   { x: new Date(2019, 4, 22), y: 60 },
  //   { x: new Date(2019, 4, 23), y: 90 },
  // ];

  const [ownerId, setOwnerId] = useState("");
  const [stats, setStats] = useState<STATS>({
    completed_tasks: 0,
    completion_rate: 0,
  });
  useEffect(() => {
    const id = ScorecardSubject.subscribe((payload) => setOwnerId(payload));
    return () => {
      id.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (ownerId) {
      Axios.get(`${TASKS_URL}/stats?owner_id=${ownerId}`).then((res) => {
        setStats(res.data);
      });
    }
  }, [ownerId]);

  return (
    <StatsCardSection>
      <TitleText>{title} Stats</TitleText>
      <TargetCard>
        <Text style={{ color: "whitesmoke" }}>
          {title === "Perspective" ||
          title === "Objective" ||
          title === "Scorecard"
            ? "Weighted Score"
            : "Target"}
        </Text>
        <TitleText style={{ fontSize: 24, color: "#fff", fontWeight: 600 }}>
          {title === "Perspective" ||
          title === "Objective" ||
          title === "Scorecard"
            ? numeral(weightedScore).format("0,0.00")
            : numeral(target).format("0a, 0.00")}
        </TitleText>
      </TargetCard>
      <StatsCard>
        <Text>Variance</Text>
        <TitleText style={{ fontSize: 24, fontWeight: 600 }}>
          {variance && variance > "0" ? "+" + variance : variance} {title === "KPI" ? "%" : ""}
        </TitleText>
      </StatsCard>
      <TitleText>Additional Stats</TitleText>
      <StatsCard>
        <Text> {title === "KPI" ? "Weighted Score" : "Initiatives"}</Text>
        <TitleText style={{ fontSize: 24, color: "#A28CFF", fontWeight: 600 }}>
          {title === "KPI" ? weightedScore : ""}
        </TitleText>
      </StatsCard>
      <StatsCard>
        <Text>{title === "KPI" ? "Progress" : " Tasks"}</Text>
        <TitleText style={{ fontSize: 24, fontWeight: 600, color: "#01A8CE" }}>
          {progress}
        </TitleText>
      </StatsCard>

      <span>
        <Tasks>
          <TotalInitiatives>
            <LabelText>Initiatives</LabelText>
            <TitleText>{initiativesTotal}</TitleText>
          </TotalInitiatives>
          <TaskCompletionRate>
            <LabelText>Tasks</LabelText>
            <CardsContainer>
              <ProgressCard
                backgroundColor="#1095b0"
                percent={stats.completion_rate}
                title="Completed"
                value={stats.completed_tasks}
              />
              {/* <ProgressCard
                backgroundColor="#454748"
                percent={40}
                title="Completed on Time"
                value={50}
              /> */}
            </CardsContainer>
          </TaskCompletionRate>
        </Tasks>

        {/* <SmallLineGraph
          actual={numeral(actual).format("0a, 0.00")}
          title={title}
          Data={Data}
        /> */}
      </span>
    </StatsCardSection>
  );
};

export default SummaryStatistcs;

const StatsCardSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 0.2fr 1fr 0.2fr 1fr 1.2fr;
  column-gap: 1em;
  row-gap: 1em;
  ${TitleText} {
    grid-column: 1 / span 2;
    color: #214160;
    font-weight: normal;
  }
  span {
    grid-column: 1 / span 2;
  }
`;

const StatsCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em 2em;
  border-radius: 0.5em;
  align-items: baseline;
  background-color: #f5f6fb;
`;
const TargetCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em 2em;
  border-radius: 0.5em;
  align-items: baseline;
  background-image: linear-gradient(to left, #01A8CE, #a28cff);
`;
const Text = styled.h4`
  margin: 0;
  font-size: 0.875em;
  font-weight: normal;
  color: #01A8CE;
  opacity: 0.6;
  line-height: 24px;
`;

const Tasks = styled.div`
  display: flex;
`;

const TotalInitiatives = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${LabelText} {
    font-size: 16px;
    font-weight: bold;
  }
  ${TitleText} {
    font-size: 4rem;
    font-weight: 900;
  }
`;

const TaskCompletionRate = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 2em;
  margin-top: 1.5em;
  flex: 1;
  ${LabelText} {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0.5em;
    margin-left: 1rem;
  }
`;

const CardsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
